module.exports = __webpack_public_path__ + "static/img/food-policy023.6cba99b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/food-policy023.png
// module id = xbwP
// module chunks = 1